import TrackingService, {
  type GenericEventParams,
} from "@/services/TrackingService"

type EnrolmentEventParams = GenericEventParams & {
  step?: string
  field?: string
}

export const trackEnrolment = (
  eventName: string,
  params?: EnrolmentEventParams,
) => {
  TrackingService.sendEvent(eventName, {
    eventCategory: "enrolment",
    ...params,
  })
}
